import { Outlet } from 'react-router-dom';

const PaymentsLayout = () => {
  return <Outlet />;
};

export default PaymentsLayout;
